angular.module('shared').directive('reactTemplateEditor', function() {
  return {
    restrict: 'E',
    template: require('templates/shared/react_template_editor.html.slim'),
    scope: {
      template: '=',
      hideName: '=',
      displayPurpose: '=',
      displaySequenceMergeTags: '=',
      displayRollCallMergeTags: '=',
      displayBookingMergeTags: '=',
      displayMembershipMergeTags: '=',
      displayPaymentMergeTags: '=',
      displayGradingEventMergeTags: '=',
      error: '=',
      toolbarStatic: '=',
      disabled: '=',
      onLoad: '&'
    },
    controller: ["$scope", "$rootScope", function($scope, $rootScope) {
      $scope.mobileAppMeta = $rootScope.mobileAppMeta;
      $rootScope.$watch('mobileAppMeta', function(meta) {
        return $scope.mobileAppMeta = meta;
      });
      return $scope.onChange = function(template) {
        return angular.extend($scope.template, template);
      };
    }]
  };
});
